// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LhrUkdGE0flrft {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.fqxDN62aQNF8fC {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-bottom: 116px;
}
`, ""]);
// Exports
export var skeleton = `LhrUkdGE0flrft`;
export var spinner = `fqxDN62aQNF8fC`;
export default ___CSS_LOADER_EXPORT___;
